import { OnInit, AfterViewInit, Component, Input, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalService } from "src/app/services/global.service";
import { GraphService } from "src/app/services/graphs.service";
import { ConfigModel, FinSalesRevenueModel } from "src/app/models/graphs.model";
import { MessageService } from "src/app/services/message.service";

@Component({
    selector: 'app-fin-sales-revenue',
    templateUrl: './salesRevenue.component.html',
    styleUrls: ['../../home/home.component.scss']
})

export class SalesRevenueComponent implements OnInit, AfterViewInit {

    graphService: Observable<any>;
    graphData: ConfigModel = new ConfigModel();
    finChart: Object;
    initialQuarterYear: string[];

    @Input() fin_Revenue_Name1: string;
    @Input() fin_Revenue_Name2: string;
    @Input() fin_Revenue_Name3: string;
    @Input() fin_Revenue_Name4: string;
    @Input() fin_Revenue_1: number;
    @Input() fin_Revenue_2: number;
    @Input() fin_Revenue_3: number;
    @Input() fin_Revenue_4: number;
    @Input() fin_Revenue_Max: number;

    initialQuarter: number;
    @Input() initialYear: number;
    @Output() fin_Revenue_Quarter = new EventEmitter();
    @Output() fin_Revenue_Year = new EventEmitter();

    @Output() revenueName1 = new EventEmitter();
    @Output() revenueName2 = new EventEmitter();
    @Output() revenueName3 = new EventEmitter();
    @Output() revenueName4 = new EventEmitter();

    constructor(private globals: GlobalService,
        private graph: GraphService,
        private messageService: MessageService) {
        this.graphData = new ConfigModel();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.load();
        })
    }

    ngOnInit(): void {
        
    }

    load() {
        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
            this.initialQuarterYear = this.graphData.fin_Revenue_Name1.split(" ");
            this.initialQuarter = parseInt(this.initialQuarterYear[0].slice(1, 3));
            this.initialYear = parseInt(this.initialQuarterYear[1]);
            this.fin_Revenue_Quarter.emit(this.initialQuarter);
            this.fin_Revenue_Year.emit(this.initialYear);

            this.finSalesRevenueChart();
        });
    }

    refresh() {

        this.switchQuarter();

        this.graphData.fin_Revenue_1 = this.fin_Revenue_1;
        this.graphData.fin_Revenue_2 = this.fin_Revenue_2;
        this.graphData.fin_Revenue_3 = this.fin_Revenue_3;
        this.graphData.fin_Revenue_4 = this.fin_Revenue_4;
        this.graphData.fin_Revenue_Max = this.fin_Revenue_Max;

        var x1 = this.graphData.fin_Revenue_1;
        var y1: number = +x1;
        this.graphData.fin_Revenue_1 = y1;

        var x2 = this.graphData.fin_Revenue_2;
        var y2: number = +x2;
        this.graphData.fin_Revenue_2 = y2;

        var x3 = this.graphData.fin_Revenue_3;
        var y3: number = +x3;
        this.graphData.fin_Revenue_3 = y3;

        var x4 = this.graphData.fin_Revenue_4;
        var y4: number = +x4;
        this.graphData.fin_Revenue_4 = y4;

        var x5 = this.graphData.fin_Revenue_Max;
        var y5: number = +x5;
        this.graphData.fin_Revenue_Max = y5;

        this.finSalesRevenueChart();
    }

    changeQuarter(id) {

        this.initialQuarter = id;
        this.switchQuarter();

        this.revenueName1.emit(this.graphData.fin_Revenue_Name1);
        this.revenueName2.emit(this.graphData.fin_Revenue_Name2);
        this.revenueName3.emit(this.graphData.fin_Revenue_Name3);
        this.revenueName4.emit(this.graphData.fin_Revenue_Name4);
    }

    changeYear(year) {

        this.initialYear = year;
        this.switchQuarter();
        this.revenueName1.emit(this.graphData.fin_Revenue_Name1);
        this.revenueName2.emit(this.graphData.fin_Revenue_Name2);
        this.revenueName3.emit(this.graphData.fin_Revenue_Name3);
        this.revenueName4.emit(this.graphData.fin_Revenue_Name4);
    }


    switchQuarter() {

        let assignedYear = this.initialYear;

        if (this.initialQuarter == 1) {

            this.graphData.fin_Revenue_Name1 = "Q1" + " " + assignedYear;
            this.graphData.fin_Revenue_Name2 = "Q2" + " " + assignedYear;
            this.graphData.fin_Revenue_Name3 = "Q3" + " " + assignedYear;
            this.graphData.fin_Revenue_Name4 = "Q4" + " " + assignedYear;
        } else if (this.initialQuarter == 2) {

            this.graphData.fin_Revenue_Name1 = "Q2" + " " + assignedYear;
            this.graphData.fin_Revenue_Name2 = "Q3" + " " + assignedYear;
            this.graphData.fin_Revenue_Name3 = "Q4" + " " + assignedYear;
            this.graphData.fin_Revenue_Name4 = "Q1" + " " + (++assignedYear);
        } else if (this.initialQuarter == 3) {

            this.graphData.fin_Revenue_Name1 = "Q3" + " " + assignedYear;
            this.graphData.fin_Revenue_Name2 = "Q4" + " " + assignedYear;
            this.graphData.fin_Revenue_Name3 = "Q1" + " " + (++assignedYear);
            this.graphData.fin_Revenue_Name4 = "Q2" + " " + assignedYear;
        } else if (this.initialQuarter == 4) {

            this.graphData.fin_Revenue_Name1 = "Q4" + " " + assignedYear;
            this.graphData.fin_Revenue_Name2 = "Q1" + " " + (++assignedYear);
            this.graphData.fin_Revenue_Name3 = "Q2" + " " + assignedYear;
            this.graphData.fin_Revenue_Name4 = "Q3" + " " + assignedYear;

        }
    }

    finSalesRevenueChart() {

        this.finChart = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Sales Revenue',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: '',
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                allowDecimals: false,
                tickInterval: 1,
                type: "category",
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
            },
            yAxis: [{
                title: {
                    text: '$ million',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.fin_Revenue_Max,
                tickInterval: this.graphData.fin_Revenue_Max,
                minorTickInterval: this.graphData.fin_Revenue_Max,
                majorTickInterval: this.graphData.fin_Revenue_Max,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
            }],
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        color: "gray"
                    }
                }
            },
            series: [
                {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name1, y: this.graphData.fin_Revenue_1 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name2, y: this.graphData.fin_Revenue_2 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name3, y: this.graphData.fin_Revenue_3 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name4, y: this.graphData.fin_Revenue_4 }],
                }],
            colors: ["#d4d3d3", "#b6c8d6", "#85b1d3", "#58a1d8"]
        };
    }

    saveFinSalesRevenueData() {

        this.globals.hasLoaded = false;

        let finSalesRevenueModel: FinSalesRevenueModel = new FinSalesRevenueModel();
        finSalesRevenueModel.revenue_Name1 = this.fin_Revenue_Name1;
        finSalesRevenueModel.revenue_Name2 = this.fin_Revenue_Name2;
        finSalesRevenueModel.revenue_Name3 = this.fin_Revenue_Name3;
        finSalesRevenueModel.revenue_Name4 = this.fin_Revenue_Name4;
        finSalesRevenueModel.revenue_1 = this.fin_Revenue_1;
        finSalesRevenueModel.revenue_2 = this.fin_Revenue_2;
        finSalesRevenueModel.revenue_3 = this.fin_Revenue_3;
        finSalesRevenueModel.revenue_4 = this.fin_Revenue_4;
        finSalesRevenueModel.revenue_Max = this.fin_Revenue_Max;

        let jsonObject: any = JSON.stringify(finSalesRevenueModel);

        this.graphService = this.graph.postFinSalesRevenue(jsonObject);

        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved Financial Sales Revenue Data Successfully");
            }, 200)
            // this.router.navigate(['/']);
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving Financial Sales Revenue details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }
}